module.exports = __webpack_public_path__ + "static/media/imge-6.f193b894.jpg";